import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { EmployerData } from '../employerData';
import { EmployerService } from '../employer.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthService } from 'src/app/auth/auth.service';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';


interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-create-employer-profile',
  templateUrl: './create-employer-profile.component.html',
  styleUrls: ['./create-employer-profile.component.css']
})
export class CreateEmployerProfileComponent implements OnInit {
  @Input() isEditProfile: boolean;
  employer_id:string;
  employer_data:any = {}
  public profile:FormGroup;
  public company_details:FormGroup;
  foods: Food[] = [
    {value: '1-15', viewValue: '1-15'},
    {value: '16-30', viewValue: '16-30'},
    {value: '31-100', viewValue: '31-100'},
    {value: '101-1000', viewValue: '101-1000'},
    {value: '1001+', viewValue: '1001+'}
  ];

  file: File;
  card = {
    form1: true,
    form2: true,
  }

  employerData: EmployerData = {
    _id: '',
    profile: {
      first_name: '',
      last_name: '',
      email_id: '',
      mobile: '',
      address: '',
      profile_image_url: null,
    },
    company_details: {
      company_name: '',
      company_website: '',
      company_logo: null,
      job_role: '',
      employee_size: null,
      info: ''
    },
  }
  termsvalue = false;
  statusFailure = false;
  statusSuccess = false;
  statusLoading = false;
  locationControl = new FormControl();
  locationControl2 = new FormControl();
  filteredLocations: Observable<string[]>;
  filteredLocations2: Observable<string[]>;
  locationOptions: string[] = [];
  locationOptions2: string[] = [];
  hide_tc = false;
  
  private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public formThree: Observable<boolean> = this.formThreeSubject.asObservable();

  // private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  // private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // public formThree: Observable<boolean> = this.formThreeSubject.asObservable();

  constructor(private router: Router, private employerService: EmployerService, private storage: AngularFireStorage, private auth: AuthService, private _snackBar: MatSnackBar,
              private formBuilder:FormBuilder ) { }
   
  next(formName, el: HTMLElement, current) {
    let currentName = 'form' + current;
    if (currentName == 'form1') {
      for (const i in this.profile.controls) {
        this.profile.controls[i].markAsDirty();
        this.profile.controls[i].updateValueAndValidity();        
      }
      if(this.profile.status == "VALID"){
        console.log(this.profile.value)
        this.employerData.profile = this.profile.value
        this.employerData.company_details = this.company_details.value
        console.log(this.employerData);
        this.employerService.updateEmployerDetails(this.employerData).subscribe(
          () => {
            this._snackBar.open('Basic information saved successfully', null, {
              duration: 2000
            });
          },
          (error) => {
            console.log(error);
            this._snackBar.open(error, null, {
              duration: 2000
            });
          }
        )
        this.scroll(formName, el, current);
      }else{
        this._snackBar.open('please fill all basic details', 'Okay', {
          duration: 5000
        });
      }
    }else if(currentName == 'form2'){
      for (const i in this.company_details.controls) {
        this.company_details.controls[i].markAsDirty();
        this.company_details.controls[i].updateValueAndValidity();
      }
      if(this.company_details.status == 'VALID'){
        this.scroll(formName, el, current);
      }else{
        this._snackBar.open('please fill all company details', 'Okay', {
          duration: 5000
        });
      }
    }else{
      this.scroll(formName, el, current);
      console.log("120")
      console.log(this.employerData)
    }
  }

  scroll(formName, el: HTMLElement, current) {
    let name: any = 'form' + formName + 'Subject';
    let currentName = 'form' + current;
    this.card[currentName] = false;
    this[name].next(false);
    setTimeout(
      () => {
        el.scrollIntoView({ behavior: 'smooth' });
      },
      100);
  }

  onChange(event){
    this.employerData.profile.first_name = String(this.employerData.profile.first_name).trim().replace(/\s\s+/g, ' ');
    this.employerData.profile.last_name = String(this.employerData.profile.last_name).trim().replace(/\s\s+/g, ' ');
    this.employerData.profile.mobile = String(this.employerData.profile.mobile).trim().replace(/\s\s+/g, ' ');
    this.employerData.profile.address = String(this.employerData.profile.address).trim().replace(/\s\s+/g, ' ');
    this.employerData.company_details.company_name = String(this.employerData.company_details.company_name).trim().replace(/\s\s+/g, ' ');
    this.employerData.company_details.company_website = String(this.employerData.company_details.company_website).trim().replace(/\s\s+/g, ' ');
    this.employerData.company_details.job_role = String(this.employerData.company_details.job_role).trim().replace(/\s\s+/g, ' ');
    this.employerData.company_details.info = String(this.employerData.company_details.info).trim().replace(/\s\s+/g, ' ');
  } 

  fileChange(type, event) {
    if (type == 'profile') {
      this.file = event.target.files[0];
      var filename = Date.now();
      const filePath = 'profile_images/' + filename;
      const task = this.storage.upload(filePath, this.file).snapshotChanges().subscribe(
        (a) => {
          a.ref.getDownloadURL().then(
            (url) => {
              console.log(url);
              this.employerData.profile.profile_image_url = url;
            }
          )
        }
      );
    }
    else if (type == 'company') {
      this.file = event.target.files[0];
      var filename = Date.now();
      const filePath = 'company/' + filename;
      const task = this.storage.upload(filePath, this.file).snapshotChanges().subscribe(
        (a) => {
          a.ref.getDownloadURL().then(
            (url) => {
              this.employerData.company_details.company_logo = url;
              console.log(url)
            }
          )
        }
      );
    }
  }

  edit(formNumber, index?) {
    let name = 'form' + formNumber;
    this.card[name] = true;
  }


  ngOnInit() {
    this.profile = this.formBuilder.group({
      first_name: ["",[Validators.required]],
      last_name: ["", [Validators.required]],
      email_id: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      address: ["", [Validators.required]],
      profile_image_url: [""]
    });
    this.company_details = this.formBuilder.group({
      company_name: ["", [Validators.required]],
      company_website: ["", [Validators.required]],
      job_role: ["", [Validators.required]],
      employee_size: ["", [Validators.required]],
      info: ["", [Validators.required]],
      company_logo: [""]
    })

    this.employerData.profile.first_name = localStorage.getItem('first_name');
    this.employerData.profile.last_name = localStorage.getItem('last_name');
    this.employerData.profile.email_id = localStorage.getItem('email_id');
    setTimeout(()=>{
      this.profile.setValue(this.employerData.profile)
    },500)
    this.auth.getUserId().subscribe(
      (a) => {
    
        console.log(a)
        this.employerService.getEmployerDetails(a.uid).subscribe(data=>{
          console.log(data)
          if(data['profile']){
           this.profile.setValue(data['profile'])
          }
          if(data['company_details']){
            this.company_details.setValue(data['company_details'])
          }
        })
        this.employerData._id = a.uid;
        console.log(this.employerData)
      }
    );
    this.getEmployerDetails();
    this.updateLocations();
    this.updateLocations2();
  }

  updateLocations() {
    this.filteredLocations = this.locationControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterLocations(value))
    );
  }
  updateLocations2() {
    this.filteredLocations2 = this.locationControl2.valueChanges.pipe(
      startWith(''),
      map(value => this._filterLocations2(value))
    );
  }

  getLocations(value) {
    if(value){
      this.employerService.getLocations(value).subscribe(
        (a: any) => {
          let data = [];
          this.locationOptions = [];
          data = a.predictions;
          data.forEach(
            (q) => {
              this.locationOptions.push(q.terms[q.terms.length - 3].value + ', ' + q.terms[q.terms.length - 2].value);
              console.log(q.description)
            }
          )
          console.log(data);
          // this.updateLocations();
        }
      )
    }
  }
  getLocations2(event) {
    console.log(event.target.value);
    this.employerService.getLocations(event.target.value).subscribe(
      (a: any) => {
        let data = [];
        this.locationOptions2 = [];
        data = a.predictions;
        data.forEach(
          (q) => {
            this.locationOptions2.push(q.terms[q.terms.length - 3].value + ', ' + q.terms[q.terms.length - 2].value);
            console.log(q.description)
          }
        )
        console.log(data);
        this.updateLocations2();
      }
    )
  }

  terms(event){
   if(event.target.checked){
     this.termsvalue = true;
     this.hide_tc = false;
   }else{
     this.termsvalue = false;
   }
 }

  onSubmit() { 
    for (const i in this.company_details.controls) {
      this.company_details.controls[i].markAsDirty();
      this.company_details.controls[i].updateValueAndValidity();
    }
    if(this.company_details.status=='VALID'){
      this.employerData.company_details = this.company_details.value
      this.hide_tc = false;
        console.log(this.employerData);
        this.statusLoading = true;
        this.employerService.updateEmployerDetails(this.employerData).subscribe(
          () => {
            console.log("Success");
            this.statusSuccess = true;
            this.statusFailure = false;
            this.statusLoading = false;
          },
          (error) => {
            this.statusFailure = true;
            this.statusSuccess = false;
            this.statusLoading = false;
          }
        )
    }
  }

  getEmployerDetails(){
    this.auth.getUserId().subscribe(
      (a) => {
        console.log(a)
        this.employerService.getEmployerDetails(a.uid).subscribe(
          (a: EmployerData) => {
            console.log(a)
            if(a){
              // this.employer_data = a
              // this.employer_id = a._id;
              this.prefillValues(a)
            } else {
              this.employer_data = JSON.parse(localStorage.getItem('user'))
             // this.employer_id = this.employer_data._id;
              console.log(this.employer_data)
              this.prefillValues(this.employer_data)
            }
          }
        )
      }
    )
  }

  prefillValues(data){
    console.log(data)
    this.profile.controls.firstName.setValue(data.profile.first_name);
    this.profile.controls.lastName.setValue(data.profile.last_name);
    this.profile.controls.email_id.setValue(data.profile.email_id);
    this.profile.controls.mobile.setValue(data.profile.mobile);
    this.profile.controls.address.setValue(data.profile.address);
    this.profile.controls.profile_image_url.setValue(data.profile.profile_image_url);
  }

  private _filterLocations(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.locationOptions.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
  private _filterLocations2(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.locationOptions2.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
}

